export default function formatDate(date, options = {}, locale = 'en-US') {
  if (!date) {
    return '';
  }

  return new Date(date).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...options
  });
}
